/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Brevalt API
 * Customer API of Brevalt (CRA vulnerability reporting). Errors are RFC 9457 problem+json.
 * OpenAPI spec version: 0.33.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  Problem,
  SearchParams,
  SearchResults
} from '../model';

import { customerFetch } from '../../../http.ts';
import type { ErrorType } from '../../../http.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getSearchUrl = (params: SearchParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/search?${stringifiedParams}` : `/api/v1/search`
}

/**
 * Case-insensitive. product: name (exact, prefix or contains); version: label (exact, prefix or contains) or "<product name> <label>" (prefix, with a space); component: name prefix in the current SBOMs, or a purl prefix (pkg:type/namespace/name...); vulnerability: id, EUVD id or an alias (CVE, GHSA, ...), exact or prefix ("cve" lists the vulnerabilities of your open findings); case: human id (exact or prefix), a vulnerability id of the case (exact) or every word in the title. Ranked exact, prefix, contains; then active/open, exploited and severity first. Only what you may see: your product scope for every kind, cases only with case.read (kinds lists what was searched). At most limit hits per kind and 25 in all. 400 query-too-short (fewer than 2 characters after trimming), query-too-long (over 100), invalid-query, invalid-limit (also a limit that is not a number); 429 too-many-searches with Retry-After; 503 search-timeout when a statement takes over 3 s (type a longer query).
 * @summary Search products, versions, components, vulnerabilities and cases at once (the top bar)
 */
export const search = async (params: SearchParams, options?: Parameters<typeof customerFetch>[1]): Promise<SearchResults> => {

  return customerFetch<SearchResults>(getSearchUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSearchQueryKey = (params?: SearchParams,) => {
    return [
    `/api/v1/search`, ...(params ? [params] : [])
    ] as const;
    }


export const getSearchQueryOptions = <TData = Awaited<ReturnType<typeof search>>, TError = ErrorType<Problem>>(params: SearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof search>>, TError, TData>>, request?: SecondParameter<typeof customerFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof search>>> = ({ signal }) => search(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof search>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SearchQueryResult = NonNullable<Awaited<ReturnType<typeof search>>>
export type SearchQueryError = ErrorType<Problem>


export function useSearch<TData = Awaited<ReturnType<typeof search>>, TError = ErrorType<Problem>>(
 params: SearchParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof search>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof search>>,
          TError,
          Awaited<ReturnType<typeof search>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customerFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearch<TData = Awaited<ReturnType<typeof search>>, TError = ErrorType<Problem>>(
 params: SearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof search>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof search>>,
          TError,
          Awaited<ReturnType<typeof search>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customerFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearch<TData = Awaited<ReturnType<typeof search>>, TError = ErrorType<Problem>>(
 params: SearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof search>>, TError, TData>>, request?: SecondParameter<typeof customerFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Search products, versions, components, vulnerabilities and cases at once (the top bar)
 */

export function useSearch<TData = Awaited<ReturnType<typeof search>>, TError = ErrorType<Problem>>(
 params: SearchParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof search>>, TError, TData>>, request?: SecondParameter<typeof customerFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSearchQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






